export default __webpack_public_path__ + "static/media/directory-1.c1e4d8ac.jpg";